import { render } from "./UsuariosPage.vue?vue&type=template&id=1189b2b4"
import script from "./UsuariosPage.vue?vue&type=script&lang=js"
export * from "./UsuariosPage.vue?vue&type=script&lang=js"

import "./UsuariosPage.vue?vue&type=style&index=0&id=1189b2b4&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__